import { render } from "./FieldsConfigModal.vue?vue&type=template&id=e1e6bf70"
import script from "./FieldsConfigModal.vue?vue&type=script&lang=js"
export * from "./FieldsConfigModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__